import { Component, Input, Output, EventEmitter } from '@angular/core';
import { collapseAnimation } from 'angular-animations';

@Component({
    selector: 'app-expandable-panel',
    templateUrl: './expandable-panel.component.html',
    styleUrls: ['./expandable-panel.component.scss'],
    animations: [collapseAnimation()],
    standalone: false
})
export class ExpandablePanelComponent {
    @Input() public expanded: boolean;
    @Output() public panelToggled = new EventEmitter();

    constructor() {}

    public togglePanel(): void {
        if (this.panelToggled) {
            this.panelToggled.emit();
        }

        this.expanded = !this.expanded;
    }
}
